<script setup>

import InputText from "primevue/inputtext";
import Password from "primevue/password";
import Button from "primevue/button";
import {usePage} from "@inertiajs/vue3";
import {useForm} from "laravel-precognition-vue-inertia";
import InputIcon from "primevue/inputicon";
import IconField from "primevue/iconfield";

const form = defineModel()
</script>

<template>

    <div class="w-full flex flex-col h-full">
        <div class="grid gap-4 m-5 max-lg:mx-0 max-lg:pt-4 mt-0">
            <div class="flex flex-wrap gap-4">

                <!-- Jméno -->
                <div class="flex flex-col items-start gap-1">
                    <label for="smtp_name" class="text-sm font-medium text-gray-700 dark:text-gray-300">{{ $t('settings.field_name') }}</label>
                    <IconField>
                        <InputIcon class="pi pi-user" />
                        <InputText id="smtp_name"
                                   v-model="form.smtp_name"
                                   @change="form.validate('smtp_name')"
                                   class="max-md:w-full"
                                   :class="{'p-invalid': form.invalid('smtp_name')}"
                        >
                        </InputText>
                    </IconField>
                    <small v-if="form.invalid('smtp_name')" class="p-error">
                        {{ form.errors['smtp_name'] }}
                    </small>
                </div>

                <!-- Emailová adresa -->
                <div class="flex flex-col items-start gap-1">
                    <label for="smtp_address" class="text-sm font-medium text-gray-700 dark:text-gray-300">{{ $t('settings.email_address') }}</label>
                    <IconField>
                        <InputIcon class="pi pi-envelope" />
                        <InputText id="smtp_address"
                                   v-model="form.smtp_address"
                                   class="max-md:w-full"
                                   @change="form.validate('smtp_address')"
                                   :class="{'p-invalid': form.invalid('smtp_address')}">
                        </InputText>
                    </IconField>
                    <small v-if="form.invalid('smtp_address')" class="p-error">
                        {{ form.errors['smtp_address'] }}
                    </small>
                </div>

                <div class="col-span-1 flex flex-col gap-1">
                    <label for="smtp_server" class="text-sm font-medium text-gray-700 dark:text-gray-300">{{ $t('settings.email_server') }}</label>
                    <IconField>
                        <InputIcon class="pi pi-server" />
                        <InputText id="smtp_server"
                                   v-model="form.smtp_server"
                                   @change="form.validate('smtp_server')"
                                   :class="{'p-invalid': form.invalid('smtp_server')}">
                        </InputText>
                    </IconField>
                    <small v-if="form.invalid('smtp_server')" class="p-error">
                        {{ form.errors['smtp_server'] }}
                    </small>
                </div>
                <div class="flex flex-col col-span-1 items-start gap-1">
                    <label for="smtp_port" class="text-sm font-medium text-gray-700 dark:text-gray-300">{{ $t('settings.email_port') }}</label>
                    <IconField>
                        <InputIcon class="pi pi-hashtag" />
                        <InputText id="smtp_port"
                                   v-model="form.smtp_port"
                                   @change="form.validate('smtp_port')"
                                   :class="{'p-invalid': form.invalid('smtp_port')}"
                                   class="max-md:w-full"
                                   keyfilter="int">
                        </InputText>
                    </IconField>
                    <small v-if="form.invalid('smtp_port')" class="p-error">
                        {{ form.errors['smtp_port'] }}
                    </small>
                </div>

                <!-- Uživatelské jméno -->
                <div class="flex flex-col items-start gap-1">
                    <label for="smtp_username" class="text-sm font-medium text-gray-700 dark:text-gray-300">{{ $t('settings.email_username') }}</label>
                    <IconField>
                        <InputIcon class="pi pi-id-card" />
                        <InputText id="smtp_username"
                                   v-model="form.smtp_username"
                                   class="max-md:w-full"
                                   fluid
                                   @change="form.validate('smtp_username')"
                                   :class="{'p-invalid': form.invalid('smtp_username')}">
                        </InputText>
                    </IconField>
                    <small v-if="form.invalid('smtp_username')" class="p-error">
                        {{ form.errors['smtp_username'] }}
                    </small>
                </div>

                <!-- Heslo -->
                <div class="flex flex-col items-start gap-1">
                    <label for="smtp_password" class="text-sm font-medium text-gray-700 dark:text-gray-300">{{ $t('settings.email_password') }}</label>
                    <IconField>
                        <InputIcon class="pi pi-lock" />
                        <Password id="smtp_password"
                                  v-model="form.smtp_password"
                                  @change="form.validate('smtp_password')"
                                  :class="{'p-invalid': form.invalid('smtp_password')}"
                                  :placeholder="$t('settings.email_password_placeholder')"
                                  class="max-md:w-full"
                                  fluid
                                  toggleMask>
                        </Password>
                    </IconField>
                    <small v-if="form.invalid('smtp_password')" class="p-error">
                        {{ form.errors['smtp_password'] }}
                    </small>
                </div>

            </div>
            <!-- Uložit tlačítko -->
        </div>
    </div>

</template>

<style scoped lang="scss">

</style>
